import { Component, ContentChild, input, output, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonComponent, ButtonSeverity, ButtonSize } from '../../ui/button/button';
import { Arrow } from '../../icons/arrow/arrow';

@Component({
  standalone: true,
  selector: 'app-data-table',
  imports: [TableModule, NgTemplateOutlet, ButtonComponent, Arrow],
  templateUrl: './data-table.html',
  styleUrl: './data-table.scss',
  host: {
    '[class.is-empty]': '!isLoading() && value().length === 0',
  },
})
export class DataTable {
  value = input<any[]>([]);
  first = input<number>(0);
  rows = input<number>(10);
  totalRecords = input<number>(0);
  isLoading = input<boolean>(false);
  hasPreviousPage = input<boolean>(false);
  hasNextPage = input<boolean>(false);
  tableStyleClass = input<string>('');

  lazyLoad = output<any>();
  prevPage = output<void>();
  nextPage = output<void>();

  @ContentChild('tableHeader') headerTpl?: TemplateRef<any>;
  @ContentChild('tableBody') bodyTpl?: TemplateRef<any>;
  @ContentChild('tableEmpty') emptyTpl?: TemplateRef<any>;
  @ContentChild('tableLoading') loadingTpl?: TemplateRef<any>;

  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonSeverity = ButtonSeverity;
}
